import sortCompare, { tableSortCompare } from "@/services/SortService";
import type { Store } from "vuex";
import type { RootState } from "@/store";
import PermissionService from "@/services/PermissionService";
import FileService from "@/services/FileService";
import BandwidthService from "@/services/BandwidthService";
import { ConfigDownloadService } from "@/services/ConfigDownloadService";
import ImportConfigService from "@/services/ImportConfigService";
import { CsvService } from "@/services/CsvService";

/** 業務ロジック */
export default class AppService {
  constructor(private store: Store<RootState>) {}

  /** 権限系 */
  readonly permission = new PermissionService(this.store);
  /** ファイル操作系 */
  readonly file = new FileService();
  /** ソート（Array.prototype.sort向け） */
  readonly sortCompare = sortCompare;
  /** ソート（AppTableのsort-compare向け） */
  readonly tableSortCompare = tableSortCompare;
  /** 帯域オブジェクトの操作 */
  readonly bandwidth = new BandwidthService();
  /** 設定ダウンロード・アップロード */
  readonly configDownload = new ConfigDownloadService(this.file);
  /** 設定インポート */
  readonly importConfig = new ImportConfigService();
  /** CSV関連の操作 */
  readonly csvService = new CsvService(this.file);
}
